import { useState } from "react";
import "../../../styles/profile/textAreaWithCounter.scss";

function TextAreaWithCounter(props) {
	const [isFocused, setIsFocused] = useState(false);

	return (
		<div
			className={`text-area-counter flex-column jc-c ${
				isFocused ? "focus-active" : ""
			}`}
		>
			<textarea
				className={`edit-description-textarea`}
				placeholder={props.placeholder}
				value={props.value}
				onFocus={(e) => {
					setIsFocused(true);
				}}
				onBlur={(e) => {
					setIsFocused(false);
				}}
				onChange={(e) => {
					props.onChange(e.target.value);
				}}
				rows={2}
				maxLength={400}
			/>
			<p className="char-counter">{props.value.length}/400</p>
		</div>
	);
}

export default TextAreaWithCounter;
